/**
 * WelcomeToast — Micro-onboarding welcome message on first workspace entry
 *
 * Reads sessionStorage for 'decarboniq_welcome_role' set after signup.
 * Shows role-specific welcome message once, then clears the flag.
 */
import { useEffect } from "react";
import { toast } from "sonner";

const WELCOME_MESSAGES = {
  sme: {
    title:   "Welcome to your SME Workspace",
    message: "Let's calculate your emissions in 2 minutes. Start with Step 2 — Data Input.",
  },
  corporate: {
    title:   "Welcome to your Corporate Workspace",
    message: "Start by setting up your organisation structure. Add your first site to begin.",
  },
  project: {
    title:   "Welcome to your Project Workspace",
    message: "Define your baseline to estimate impact. Create your first assessment to start.",
  },
  fi: {
    title:   "Welcome to your FI Workspace",
    message: "Review incoming climate finance deals. Your pipeline is ready.",
  },
};

export default function WelcomeToast() {
  useEffect(() => {
    const role = sessionStorage.getItem("decarboniq_welcome_role");
    if (!role) return;
    const msg = WELCOME_MESSAGES[role];
    if (!msg) return;
    // Clear immediately so it only shows once
    sessionStorage.removeItem("decarboniq_welcome_role");
    // Delay slightly to let page settle
    setTimeout(() => {
      toast.success(msg.title, {
        description: msg.message,
        duration: 8000,
      });
    }, 800);
  }, []);

  return null; // Renders nothing — just triggers the toast
}
